function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOutbound = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.049,
    height: 10.958,
    viewBox: "0 0 13.049 10.958",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 69",
    transform: "translate(2.613 5.249)",
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "#5167fd"
    },
    d: "M0 0h9.935"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20792",
    d: "m-18421.824-3850.792 2.414-2.415-2.414-2.414",
    transform: "translate(18431.959 3858.526)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      fill: "none",
      stroke: "#5167fd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 20793",
    d: "M-18424.59-3852.131v-2.682h-7.082v9.958h7.082v-2.574",
    transform: "translate(18432.172 3855.313)",
    style: {
      strokeLinejoin: "round",
      fill: "none",
      stroke: "#5167fd"
    }
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOutbound, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Outbound.50e982ad.svg";
export { ForwardRef as ReactComponent };